import React, { useContext } from 'react';

import Badge from './badge.svg';
import { ContentContext } from 'Components/hooks/context';
import SmartText from '@reuters-graphics/react-smart-text';
import classnames from 'classnames';
import { component } from './styles.module.scss';

const Credits = () => {
  const content = useContext(ContentContext);

  return (
    <section className={classnames(component)}>
      <div className='creditbox mx-auto px-0'>
        <div className='credits mx-auto px-0'>
          <SmartText source={content.common.sources} multiline />
          <SmartText source={content.common.credits} multiline />
        </div>
        <div className='section-spacer' />
        <figure className='badge'>
          <Badge />
        </figure>

      </div>
      <div className='section-spacer' />
    </section>
  );
};

export default Credits;
